import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import { ChatChannelPayload } from '@interfaces/api/payloads/chatChannelPayload';
import { ChatEligibilityPayload } from '@interfaces/api/payloads/chatEligibilityPayload';
import { UserToken } from '@interfaces/models/userToken';
import { ApiResponse } from '@interfaces/api';
import { Channel } from 'stream-chat';

export default class ChatApiService {
  static apiBaseUrl = Environment.apiBaseUrl;

  static async createChannel(payload: ChatChannelPayload): Promise<ApiResponse<Channel>> {
    const axiosConfig = getAxiosConfig();
    const { data } = await axios.post<ApiResponse<Channel>>(`${this.apiBaseUrl}/chat/channel/`, payload, axiosConfig);
    return data;
  }

  // decalred but not used anywhere
  static async deleteDevice(deviceId) {
    const axiosConfig = getAxiosConfig();
    return axios.delete(`${this.apiBaseUrl}/chat/user/device/${deviceId}`, axiosConfig);
  }

  // decalred but not used anywhere
  static async getChannel(id) {
    const axiosConfig = getAxiosConfig();
    return axios.get(`${this.apiBaseUrl}/chat/channel/${id}`, axiosConfig);
  }

  static async getEligibility(payload: ChatEligibilityPayload): Promise<boolean> {
    const axiosConfig = getAxiosConfig();
    const {
      data: {
        data: { eligibility },
      },
    } = await axios.post(`${this.apiBaseUrl}/chat/eligibility`, payload, axiosConfig);
    return eligibility;
  }

  static async refreshToken(): Promise<UserToken> {
    const axiosConfig = getAxiosConfig();
    const {
      data: { data },
    } = await axios.get<ApiResponse<UserToken>>(`${this.apiBaseUrl}/chat/user/token`, axiosConfig);
    return data;
  }

  // decalred but not used anywhere
  static async updateDevice(payload) {
    const axiosConfig = getAxiosConfig();
    return axios.post(`${this.apiBaseUrl}/chat/user/device`, payload, axiosConfig);
  }
}
